import { BlackJackBetMoveEffect } from './../component/bj_bet_move_effect';
import Utility from "../../../../utility/utility";
import BlackJackTableView from "./blackjack_table_view";
import { BlackJack } from '../../net/proto/proto_blackjack_game';
import BlackJackTableModel from './blackjack_table_model';
import BlackJackTableModule from './blackjack_table_module';
import BlackJackTableLogic from './blackjack_table_logic';
import ModuleManager from '../../../../framework/core/module_manager';
import DialogTips from '../../../public/module/dialog_tips/dialog_tips';
import BlackJackUtility from '../../Utility/blackJack_utility';
import GameUtil from '../../../../utility/game_util';


const {ccclass, property} = cc._decorator;

@ccclass
export default class BlackjackTableSideView extends cc.Component {
   
    
    
    
    @property(cc.Button)
    standUpBtn: cc.Button = null;
    
    @property(cc.Node)
    sideBetBg: cc.Node = null;

    @property(cc.Label)
    cionTxt: cc.Label = null;

    @property(cc.Node)
    chipPos: cc.Node = null;

    @property(BlackJackBetMoveEffect)
    bankMoveEffect: BlackJackBetMoveEffect = null;

    countMoney=0;
    cardInfoArr:BlackJack.ICardInfo[]=[]
    betInfoArr:BlackJack.Player.IBetInfo[]=[]
    posInfoArr:BlackJack.IPosInfo[]
    blackjackView:BlackJackTableView=null
    blackJackTableModel:BlackJackTableModel=null
    blackJackTableModule:BlackJackTableModule=null;
    blackJackTableLogic:BlackJackTableLogic=null;
    playerInfo:BlackJack.IPlayer=null;
   
    start () {
        this.bindBtnClickEvent();
    }
    reset()
    {
        this.countMoney=0;
        this.bindBtnClickEvent();
    }
    bindBtnClickEvent() 
    {
        this.standUpBtn.node.on('click', this.standUpBtnOnClick, this)
    }

    unbindBtnClickEvent()
     {
        // let self = this
        this.standUpBtn.node.targetOff(this)
    }
    standUpBtnOnClick()
    {
        let isClickValid = Utility.btnClickValid(100)
        Utility.playButtonSound()
        if(this.blackJackTableLogic.getMainPlayerBase()!=0)
        {
            ModuleManager.instance.toast("游戏过程中，不可站起旁观");
        }
        else
        {
            let leaveCallFunc = ()=>{
                this.blackJackTableModel.send_OccupySeat_request(0);
            }
           
            ModuleManager.instance.showModule(DialogTips, { Content: '旁观后只能下旁注，是否确定要旁观？',EnterCallBack:leaveCallFunc})
        }
        
        return isClickValid
    }
    setBlackJackView(bjView:BlackJackTableView)
    {
        this.blackjackView=bjView
    }
    setBlackJackModel(model:BlackJackTableModel)
    {
        this.blackJackTableModel=model
    }
    setBlackJackLogic(bjLogic:BlackJackTableLogic) {
        this.blackJackTableLogic=bjLogic
    }
    setPlayerInfo(info:BlackJack.IPlayer)
    {
        this.standUpBtn.node.active=false;
        this.sideBetBg.active=false;
        return;
        if(info.playerPos!=0)
        {
            if(this.blackJackTableLogic.getMainPlayerBase()!=0)
            {
                this.standUpBtn.node.active=false;
            }
            else
            {
                this.standUpBtn.node.active=true;
            }
            this.sideBetBg.active=false;
            return
        }
        this.standUpBtn.node.active=false;
        this.sideBetBg.active=true;
        this.playerInfo=info;
        let num=this.playerInfo.coinBalance
        num=Math.round(num * 100) / 100
       
        this.cionTxt.string=GameUtil.currencyFormatting(num)

    }
    addPosInfo(info:BlackJack.IPosInfo)
    {
        this.posInfoArr.push(info)
    }
    setPlayerCion(coinBalance: number) {
        this.cionTxt.string=coinBalance.toString();
    }
}
